export const SET_EMPLOYEE_DATA = "SET::EMPLOYEE_DATA"
export const SET_ADMIN_DATA = "SET::ADMIN_DATA"
export const SET_STORE_LOCATION = "SET::STORE_LOCATION"
export const SET_SUPER_ADMIN = "SET::SUPER_ADMIN"
export const SET_KIOSK_DATA = "SET::KIOSK::DATA"
export const SET_CHARLESTON_DATA = "SET::CHARLESTON::DATA"
export const SET_ATLANTA_DATA = "SET::ATLANTA::DATA"
